function catchFunction<T>(cb: () => T): [undefined, T] | [Error] {
  try {
    return [undefined, cb()];
  } catch (e) {
    return [e as Error];
  }
}

function catchPromise<T>(promise: Promise<T>): Promise<[undefined, T] | [Error]> {
  return promise.then((data) => [undefined, data] as [undefined, T]).catch((error) => [error]);
}

export function catchError<T>(promise: Promise<T>): Promise<[undefined, T] | [Error]>;
export function catchError<T>(cb: () => T): [undefined, T] | [Error];
export function catchError<T>(
  arg: (() => T) | Promise<T>,
): Promise<[undefined, T] | [Error]> | ([undefined, T] | [Error]) {
  if (arg instanceof Promise) {
    return catchPromise(arg);
  }

  return catchFunction(arg);
}
